const sanitizeError = (error: unknown, message = 'Unknow') =>
  error instanceof Error ? error : new Error(message)

export default sanitizeError
